<template>
    <div class="slider" ref="theSlider">
        <div class="slider-overflow">
            <div class="slider-list" ref="sliderList">
                <slot></slot>
            </div>
        </div>

        <div class="slider-nav">
            <template v-if="index">
                <div class="slider-index">
                    <span class="from">{{ 1 + currentIndex }}</span> /
                    <span class="to">{{ quantity }}</span>
                </div>
            </template>

            <template v-if="dots">
                <div class="slider-dots">
                    <button
                        class="slider-dot"
                        v-for="(slide, i) in slides"
                        :class="{ active: slide.isActive }"
                        :key="slide._uid"
                        @click="selectSlide(slide)"
                    >
                        {{ ++i }}
                    </button>
                </div>
            </template>

            <template v-if="arrows">
                <button class="button-action -prev" @click="prevSlide">
                    <i class="far fa-chevron-left"></i>
                </button>
                <button class="button-action -next" @click="nextSlide">
                    <i class="far fa-chevron-right"></i>
                </button>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            arrows: {
                type: Boolean,
                default: true,
            },
            dots: {
                type: Boolean,
                default: true,
            },
            columns: {
                type: Number,
                default: 1,
            },
            index: {
                type: Boolean,
                default: false,
            },
			indexModal: {
				type: Number,
				default: 0,
			}
        },

        data() {
            return {
                slides: [],
                currentIndex: 0,
                slideWidth: 0,
                mousedown: 0,
                dragOffset: 0,
                dragStartX: 0,
                minSwipeDistance: 25,
                responsive: window.innerWidth > 768,
            }
        },

        computed: {
            quantity() {
                let num = 0
                this.slides.forEach(() => {
                    num++
                })
                return num
            },

            sliderListWidth() {
                return this.quantity * 100
            },

            sliderPosition() {
                return this.currentIndex * this.slideWidth
            },
        },

        methods: {
            selectSlide(selected) {
                this.slides.forEach((slide) => {
                    slide.isActive = slide._uid == selected._uid
                    this.currentIndex = this.slides.indexOf(selected)
                })

                if (this.responsive) {
                    // Desktop
                    this.setSliderListPosition()
                } else {
                    // Mobile
                    this.setSliderListPosition(1)
                }
            },

            getSlideWidth(col) {
                const columns = col ? col : this.columns

                try {
                    this.slideWidth = this.$refs.theSlider.scrollWidth
                } catch (error) {
                    console.log('slideWidth not found.')
                }

                this.slides.forEach((slide) => {
                    slide.slideWidth = this.slideWidth / columns
                })
            },

            setSliderListWidth() {
                try {
                    this.$refs.sliderList.style.width = (this.slideWidth * this.quantity) + 'px'
                } catch (error) {
                    console.log('slideWidth not found.')
                }
            },

            setSliderListPosition(col) {
                const columns = col ? col : this.columns
                let w = this.sliderPosition / columns

                try {
                    this.$refs.sliderList.style.transform = `translate3d(-${w}px, 0, 0)`
                } catch (error) {
                    console.log('slideWidth not found.')
                }
            },

            prevSlide() {
                if (this.currentIndex < 1) return
                this.currentIndex--
                this.selectSlide(this.slides[this.currentIndex])

                if (this.responsive) {
                    // Desktop
                    this.setSliderListPosition()
                } else {
                    // Mobile
                    this.setSliderListPosition(1)
                }
            },

            nextSlide() {
                if (this.currentIndex >= this.quantity - 1) return
                this.currentIndex++
                this.selectSlide(this.slides[this.currentIndex])

                if (this.responsive) {
                    // Desktop
                    this.setSliderListPosition()
                } else {
                    // Mobile
                    this.setSliderListPosition(1)
                }
            },

            handleMouseup() {
                this.mousedown = false
                this.dragOffset = 0
            },

            handleMousedown(e) {
                if (!e.touches) {
                    e.preventDefault()
                }
                this.mousedown = true
                this.dragStartX = 'ontouchstart' in window ? e.touches[0].clientX : e.clientX
            },

            handleMousemove(e) {
                if (!this.mousedown) {
                    return
                }
                const eventPosX = 'ontouchstart' in window ? e.touches[0].clientX : e.clientX
                const deltaX = this.dragStartX - eventPosX
                this.dragOffset = deltaX
                if (this.dragOffset > this.minSwipeDistance) {
                    this.handleMouseup()
                    this.nextSlide()
                } else if (this.dragOffset < -this.minSwipeDistance) {
                    this.handleMouseup()
                    this.prevSlide()
                }
            },

            handleResize() {
                this.responsive = window.innerWidth > 768
                this.init()
            },

            setEventListeners() {
                if ('ontouchstart' in window) {
                    this.$el.addEventListener('touchstart', this.handleMousedown)
                    this.$el.addEventListener('touchend', this.handleMouseup)
                    this.$el.addEventListener('touchmove', this.handleMousemove)
                } else {
                    this.$el.addEventListener('mousedown', this.handleMousedown)
                    this.$el.addEventListener('mouseup', this.handleMouseup)
                    this.$el.addEventListener('mousemove', this.handleMousemove)
                }
            },

            init() {
                if (this.responsive) {
                    // Desktop
                    this.getSlideWidth()
                    this.setSliderListWidth()
                    this.setSliderListPosition()
                } else {
                    // Mobile

                    this.getSlideWidth(1)
                    this.setSliderListWidth(1)
                    this.setSliderListPosition(1)
                }
                this.setEventListeners()
            },
        },

        mounted() {
            this.slides = this.$children
            this.init()
            this.selectSlide(this.slides[this.indexModal])
            this.setEventListeners()

            window.addEventListener('resize', this.handleResize)
        },

        updated() {
            this.responsive = window.innerWidth > 768
            this.init()
        },

        destroyed() {
            window.removeEventListener('resize', this.handleResize, false)
            this.$el.removeEventListener('touchstart', this.handleMousedown, false)
            this.$el.removeEventListener('touchend', this.handleMouseup, false)
            this.$el.removeEventListener('touchmove', this.handleMousemove, false)
            this.$el.removeEventListener('mousedown', this.handleMousedown, false)
            this.$el.removeEventListener('mouseup', this.handleMouseup, false)
            this.$el.removeEventListener('mousemove', this.handleMousemove, false)
        },
    }
</script>

<style lang="stylus" scoped></style>
